(() => {
  const boot = () => {
    document.querySelectorAll('[data-fwgfx]:not([data-fwgfx-ready])').forEach(init);
  };

  const init = (root) => {
    root.dataset.fwgfxReady = 'true';

    const state = new Map();
    const cards = [...root.querySelectorAll('[data-fwgfx-item]')];
    const currency = root.dataset.currency || 'USD';
    const routesRoot = window.Shopify?.routes?.root || '/';
    const codes = { 12: root.dataset.code12 || 'FWBUILD12', 15: root.dataset.code15 || 'FWBUILD15' };

    const els = {
      finishes: [...root.querySelectorAll('[data-fwgfx-finish]')],
      finishInputs: [...root.querySelectorAll('[data-fwgfx-finish-input]')],
      finishCounts: [...root.querySelectorAll('[data-fwgfx-finish-count]')],
      summary: root.querySelector('[data-fwgfx-summary]'),
      subtotal: root.querySelector('[data-fwgfx-subtotal]'),
      filterRow: root.querySelector('[data-fwgfx-filter-row]'),
      filterLabel: root.querySelector('[data-fwgfx-filter-label]'),
      filterSaving: root.querySelector('[data-fwgfx-filter-saving]'),
      kitRow: root.querySelector('[data-fwgfx-kit-row]'),
      kitSaving: root.querySelector('[data-fwgfx-kit-saving]'),
      total: root.querySelector('[data-fwgfx-total]'),
      meter: root.querySelector('[data-fwgfx-meter]'),
      meterTitle: root.querySelector('[data-fwgfx-meter-title]'),
      meterValue: root.querySelector('[data-fwgfx-meter-value]'),
      meterTrack: root.querySelector('[data-fwgfx-meter-track]'),
      meterFill: root.querySelector('[data-fwgfx-meter-fill]'),
      meterCount: root.querySelector('[data-fwgfx-meter-count]'),
      meterNext: root.querySelector('[data-fwgfx-meter-next]'),
      add: root.querySelector('[data-fwgfx-add]'),
      status: root.querySelector('[data-fwgfx-status]')
    };

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const dataFor = (card) => {
      const baseTitle = card.dataset.title || 'Product';
      const finish = card.dataset.finish || '';
      const title = finish && finish !== 'Default Title' ? `${baseTitle} — ${finish}` : baseTitle;
      return {
        id: String(card.dataset.id || ''),
        productId: String(card.dataset.productId || ''),
        title,
        finish,
        role: card.dataset.role || 'accessory',
        price: Number(card.dataset.price || 0),
        compare: Number(card.dataset.compare || 0),
        available: card.dataset.available === 'true',
        includes: String(card.dataset.includes || '').split(',').map(value => value.trim()).filter(Boolean),
        quantity: 0
      };
    };

    const selectedItems = () => [...state.values()].filter(item => item.quantity > 0);

    const selectFinish = (requestedFinish) => {
      const finish = requestedFinish === 'Silver' ? 'Silver' : 'Black';
      root.dataset.selectedFinish = finish;
      els.finishInputs.forEach(input => {
        input.checked = input.value === finish;
      });
      els.finishes.forEach(control => {
        const active = control.dataset.fwgfxFinish === finish;
        control.classList.toggle('is-active', active);
      });
    };

    const includedMap = () => {
      const map = new Map();
      selectedItems().filter(item => item.role === 'kit').forEach(kit => {
        kit.includes.forEach(id => {
          if (!map.has(id)) map.set(id, { quantity: 0, kits: [] });
          const inclusion = map.get(id);
          inclusion.quantity += kit.quantity;
          inclusion.kits.push(`${kit.title}${kit.quantity > 1 ? ` ×${kit.quantity}` : ''}`);
        });
      });
      return map;
    };

    const setQuantity = (card, next) => {
      const item = dataFor(card);
      if (!item.id || !item.available) return;

      const quantity = Math.max(0, Math.min(99, Number(next) || 0));
      if (!quantity) {
        state.delete(item.id);
      } else {
        item.quantity = quantity;
        state.set(item.id, item);
      }
      render();
    };

    const metrics = () => {
      const all = selectedItems();
      const filters = all.filter(item => item.role === 'filter');
      const kits = all.filter(item => item.role === 'kit');
      const filterUnits = filters.reduce((sum, item) => sum + item.quantity, 0);
      const percent = filterUnits >= 2 ? 15 : (kits.length && filterUnits === 1 ? 12 : 0);
      const subtotal = all.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const filterSubtotal = filters.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const filterSaving = percent ? Math.round(filterSubtotal * percent / 100) : 0;
      const kitSaving = kits.reduce((sum, item) => sum + Math.max(0, item.compare - item.price) * item.quantity, 0);
      return { all, kits, filterUnits, percent, subtotal, filterSaving, kitSaving, total: Math.max(0, subtotal - filterSaving) };
    };

    const meterCopy = (metricsValue) => {
      const count = metricsValue.filterUnits
        ? `${metricsValue.filterUnits} filter${metricsValue.filterUnits === 1 ? '' : 's'} selected`
        : 'No filters selected';

      if (metricsValue.filterUnits >= 2) {
        return {
          stage: 'max',
          title: 'Maximum filter savings unlocked',
          value: '15% OFF',
          count,
          next: `You save ${money(metricsValue.filterSaving)} on filters.`
        };
      }

      if (metricsValue.percent === 12) {
        return {
          stage: 'unlocked',
          title: 'Filter savings unlocked',
          value: '12% OFF',
          count,
          next: `Save ${money(metricsValue.filterSaving)} · Add 1 more filter for 15%.`
        };
      }

      if (metricsValue.filterUnits === 1) {
        return {
          stage: 'ready',
          title: 'One filter selected',
          value: '0% UNLOCKED',
          count,
          next: metricsValue.kits.length ? 'Add 1 more filter for 15% off.' : 'Add a setup for 12%, or 1 more filter for 15%.'
        };
      }

      return {
        stage: 'locked',
        title: 'Add a filter with any setup for 12% off',
        value: '0% UNLOCKED',
        count,
        next: '1 filter + setup = 12% off · 2 filters = 15% off'
      };
    };

    const render = () => {
      const current = metrics();
      const included = includedMap();
      const finishCounts = { Black: 0, Silver: 0 };

      current.all.forEach(item => {
        if (item.finish === 'Black' || item.finish === 'Silver') {
          finishCounts[item.finish] += item.quantity;
        }
      });

      els.finishCounts.forEach(node => {
        const finish = node.dataset.fwgfxFinishCount;
        const count = finishCounts[finish] || 0;
        node.hidden = count === 0;
        node.textContent = String(count);
      });

      cards.forEach(card => {
        const id = String(card.dataset.id || '');
        const selected = state.get(id);
        const quantity = selected?.quantity || 0;
        const inclusion = included.get(id);
        const isIncluded = Boolean(inclusion?.quantity);
        const toggle = card.querySelector('[data-fwgfx-toggle]');
        const minus = card.querySelector('[data-fwgfx-minus]');
        const plus = card.querySelector('[data-fwgfx-plus]');
        const output = card.querySelector('[data-fwgfx-qty]');
        const cardState = card.querySelector('[data-fwgfx-state]');
        const note = card.querySelector('[data-fwgfx-included]');

        card.classList.toggle('is-selected', quantity > 0);
        card.classList.toggle('is-included', isIncluded);
        if (toggle) {
          toggle.setAttribute('aria-pressed', quantity > 0 ? 'true' : 'false');
          toggle.disabled = card.dataset.available !== 'true';
        }
        if (minus) minus.disabled = quantity <= 0;
        if (plus) plus.disabled = card.dataset.available !== 'true' || quantity >= 99;
        if (output) output.textContent = String(quantity);
        if (cardState) {
          cardState.textContent = isIncluded
            ? (quantity
              ? `${quantity} extra selected`
              : `${inclusion.quantity} included`)
            : (quantity ? 'Added' : (card.dataset.available === 'true' ? 'Add' : 'Sold out'));
        }
        if (note) {
          note.hidden = !isIncluded;
          if (isIncluded) {
            const setupWord = inclusion.kits.length === 1 ? 'setup' : 'setups';
            const extraText = inclusion.quantity === 1
              ? 'Use + if you want another.'
              : 'Use + if you want more.';
            note.textContent = `Already included with your selected ${setupWord}. ${extraText}`;
          } else {
            note.textContent = '';
          }
        }
      });

      const meter = meterCopy(current);
      if (els.summary) els.summary.hidden = !current.all.length;
      if (els.subtotal) els.subtotal.textContent = money(current.subtotal);
      if (els.filterRow) els.filterRow.hidden = !current.filterSaving;
      if (els.filterLabel) els.filterLabel.textContent = `${current.percent}% filter savings`;
      if (els.filterSaving) els.filterSaving.textContent = `−${money(current.filterSaving)}`;
      if (els.kitRow) els.kitRow.hidden = !current.kitSaving;
      if (els.kitSaving) els.kitSaving.textContent = `−${money(current.kitSaving)}`;
      if (els.total) els.total.textContent = money(current.total);
      if (els.add) els.add.disabled = !current.all.length;
      if (els.meter) els.meter.dataset.stage = meter.stage;
      if (els.meterTitle) els.meterTitle.textContent = meter.title;
      if (els.meterValue) els.meterValue.textContent = meter.value;
      if (els.meterCount) els.meterCount.textContent = meter.count;
      if (els.meterNext) els.meterNext.textContent = meter.next;
      if (els.meterTrack) els.meterTrack.setAttribute('aria-valuenow', String(Math.min(2, current.filterUnits)));
      if (els.meterFill) els.meterFill.style.width = `${Math.min(2, current.filterUnits) * 50}%`;
    };

    selectFinish(root.dataset.selectedFinish || 'Black');

    els.finishInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        selectFinish(input.value);
        render();
      });
    });

    els.finishes.forEach(control => {
      control.addEventListener('click', () => {
        selectFinish(control.dataset.fwgfxFinish);
        render();
      });
    });

    cards.forEach(card => {
      card.querySelector('[data-fwgfx-toggle]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current ? 0 : 1);
      });
      card.querySelector('[data-fwgfx-minus]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current - 1);
      });
      card.querySelector('[data-fwgfx-plus]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current + 1);
      });
    });

    const cartQuantities = (cart) => {
      const quantities = new Map();
      (cart.items || []).forEach(item => {
        const id = String(item.variant_id || item.id || '');
        quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
      });
      return quantities;
    };

    els.add?.addEventListener('click', async () => {
      const current = metrics();
      if (!current.all.length) return;

      els.add.disabled = true;
      els.add.textContent = 'Adding and checking your setup…';
      if (els.status) els.status.textContent = '';

      try {
        const beforeResponse = await fetch(`${routesRoot}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!beforeResponse.ok) throw new Error('The cart could not be checked. Please refresh and try again.');
        const before = cartQuantities(await beforeResponse.json());

        const items = current.all.map(item => ({ id: Number(item.id), quantity: item.quantity }));
        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || 'Some products could not be added.');

        const afterResponse = await fetch(`${routesRoot}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!afterResponse.ok) throw new Error('Your cart could not be verified. Please open the cart and check the items.');
        const after = cartQuantities(await afterResponse.json());
        const missing = items.filter(item => {
          const id = String(item.id);
          return (after.get(id) || 0) < (before.get(id) || 0) + item.quantity;
        });
        if (missing.length) throw new Error('Some items were not confirmed in the cart. Please refresh and try again.');

        const code = current.percent ? codes[current.percent] : '';
        if (code) {
          window.location.assign(`${routesRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${routesRoot}cart`)}`);
        } else {
          window.location.assign(`${routesRoot}cart`);
        }
      } catch (error) {
        if (els.status) els.status.textContent = error.message || 'Please try again.';
        els.add.disabled = false;
        els.add.textContent = 'Add selected items to cart';
      }
    });

    render();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
